import { Col, Form, Row, Select, Card, Typography } from "antd";
import React, { useEffect, useState } from "react";
import LoadingSpin from "../../loadingSpin/LoadingSpin";
import DashboardService from "../../../services/DashboardService";
import TableViewActiveKanban from "./TableViewActiveKanban";
import ReportService from "../../../services/ReportService";
import ResponseMessage from "../../Comman/Notification/ResponseMessge";

const ViewActiveKanban = ({ userData }) => {
  const [lineData, setLineData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [getActiveKanban, setGetActiveKanban] = useState(null);
  const [sizeData, setSizeData] = useState([]);

  useEffect(() => {
    const getLineData = async () => {
      try {
        const response = await DashboardService.getLine();

        if (response?.line_no) {
          const option = response.line_no.map((line) => ({
            label: line,
            value: line,
          }));
          setLineData(option);
        } else {
          ResponseMessage.error({
            message: response?.message || "Failed to fetch line data",
          });
        }
      } catch (error) {
        console.error("Error fetching line data:", error);
        ResponseMessage.error({ message: "Failed to fetch line data" });
      }
    };

    getLineData();
  }, []);

  const handleGetData = async (value) => {
    if (!value) {
      setGetActiveKanban(null);
      setSizeData([]);
      return;
    }

    setIsLoading(true);

    try {
      const response = await ReportService.displayActiveKanban(value);

      if (response?.data?.length > 0) {
        setGetActiveKanban(response.data);

        try {
          const expandDataSource = response.data.flatMap((item) => {
            const sizes = item.size_name ? JSON.parse(item.size_name) : {};

            return Object.entries(sizes)
              .filter(([size, qty]) => qty && qty !== "")
              .map(([size, qty]) => ({
                kb_number: item.kb_number,
                size,
                size_qty: qty,
              }));
          });

          setSizeData(expandDataSource);
        } catch (jsonError) {
          console.error("Error parsing size data:", jsonError);
          setSizeData([]);
        }
      } else {
        setGetActiveKanban(null);
        setSizeData([]);
        ResponseMessage.error({ message: "No data received from server" });
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
      setGetActiveKanban(null);
      setSizeData([]);
      ResponseMessage.error({ message: "Failed to fetch kanban data" });
    } finally {
      setTimeout(() => setIsLoading(false), 700);
    }
  };

  return (
    <>
      <Card className="modern-card dashboard-filter-wrap" style={{ marginBottom: 20 }}>
        <Row gutter={[16, 16]} justify="space-between" align="middle">
          <Col xs={24} md={12}>
            <div className="page-title-wrap">
              <Typography.Text
                style={{
                  fontSize: "16px",
                  fontWeight: 600,
                  color: "#1e293b",
                  display: "block",
                }}
              >
                Filter Active Kanban
              </Typography.Text>

              <Typography.Text className="page-subtitle">
                Select a production line to view active kanban details
              </Typography.Text>
            </div>
          </Col>

          <Col xs={24} md={10} lg={8} xl={7}>
            <Form.Item
              name="selectLine"
              label="Select Line"
              style={{ marginBottom: 0 }}
            >
              <Select
                size="large"
                options={lineData}
                onChange={handleGetData}
                placeholder="Select a line"
                allowClear
                style={{ width: "100%" }}
                listHeight={250}
                popupMatchSelectWidth={true}
              />
            </Form.Item>
          </Col>
        </Row>
      </Card>

      <Card
        className="modern-card"
        style={{ position: "relative", minHeight: 220 }}
      >
        {isLoading && (
          <div className="dashboard-overlay-loader">
            <LoadingSpin />
          </div>
        )}

        {getActiveKanban ? (
          <TableViewActiveKanban
            getActiveKanban={getActiveKanban}
            sizeData={sizeData}
          />
        ) : (
          !isLoading && (
            <div
              style={{
                minHeight: 180,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#64748b",
                fontSize: 14,
                fontWeight: 500,
              }}
            >
              Select a line to view active kanban details
            </div>
          )
        )}
      </Card>
    </>
  );
};

export default ViewActiveKanban;